import React from 'react'
import { Popup } from 'semantic-ui-react'
import PricingPopupBody from "../Pricing/PricingPopupBody";
import NavbarSignup from '../../SharedComponents/Navbar/NavbarSignUp'

const pricingPopup = <Popup flowing hoverable content={<PricingPopupBody/>} trigger={<span className="linkStyle">pricing </span> }/>

export const HelpInfo = [
    {
        info: {
            icon: 'question circle outline',
            name: 'general'
        },
        faq:[
                {
                    question: "What is this all about?",
                    answer: "API Spreadsheets is the easiest way for you to use your spreadsheets as a REST API/CRUD Database"},
                {
                    question: "Why would I need to use my spreadsheets as an API?",
                    answer: <span>Lots of reasons! Some of the most commons ones we have seen are <br/>
                        1. when it's a simple data collection process that doesn't require a database<br/>
                        2. when you are working with non-tech people and want them to easily see/edit data <br/>
                        3. when you have a bunch of data in spreadsheets that you want to use in an application <br/><br/>
                        You can check out our <a href="tutorials">Use Case based Tutorials</a> to learn more
                    </span>,
                    searchAnswer: "simple data collection process that doesn't require a database, " +
                    "working with non-tech people and want them to easily see/edit data, " +
                    "bunch of data in spreadsheets that you want to use in an application"},
                {
                    question: "Can't I just use Google Sheets API or something else?",
                    answer: <span>You sure can but like many of our customers, you will quickly see how cumbersome and feature deficient Google Sheets and other tools are. Check out how easy it is to get started with us on our <a href="guides/get-started-with-api-spreadsheets">API Quickstart</a> guide. And check out all our <a href="features">features</a>!</span>,
                    searchAnswer: "You sure can but like many of our customers, you will quickly see how cumbersome and feature deficient Google Sheets and other tools are. Check out how easy it is to get started with us on our API Quickstart guide. And check out all our features!"
                },
                {
                    question: "Cool, I am ready to get started!",
                    answer: <span>Just <NavbarSignup/>, upload your file and get started from your File Information box!<br/> You can also read more details on how to get started in our the <a href="guides">Guides</a>. </span>,
                    searchAnswer: "Upload your file and get started from your File Information box! You can also read more details on how to get started in our Guides"
                },
        ]
    },
    {
        info: {
            icon: 'file alternate outline',
            name: 'local-file'
        },
        faq:[
                {
                    question: "What kind of files can I upload?",
                    answer: "You can upload files with these extensions: .xls, .xlt, .xlm, .xlsx, .xlsm, .xltx, .xltm, .xlsb, .csv, .txt"
                },
                {
                    question: "How do I upload the files?",
                    answer: "You can click on upload and select them or you can drag and drop them.",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/UploadLocalFile.png", alt: "Upload Local File"}
                },
                {
                    question: "Can I upload files only the first time?",
                    answer: "Nope! You can reupload the file in your File Information box. This preserves your API URL",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/ReuploadFile.png", alt: "Replace Local File", width: '60%'}
                },
                {
                    question: "I need to view my file. How can I do that?",
                    answer: "You can download the file in your File Information box",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/DownloadFile.png", alt: "Download Local File", width: '60%'}
                },
                {
                    question: "What size files can I upload?",
                    answer: <span>Anything under 1,500 rows you can upload for free. See our {pricingPopup} to learn more!</span>,
                    searchAnswer: "Anything under 1,500 rows you can upload for free. See our pricing to learn more!"
                },
        ]
    },
    {
        info: {
            icon: 'google drive',
            name: 'google-sheets'
        },
        faq:[
                {
                    question: "How Do I Connect to Google Sheets?",
                    answer: "Click on Google Sheets and follow the prompt",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/UploadGoogleSheets.png", alt: "Upload Google Sheets"}
                },
                {
                    question: "How many Google ACCOUNTS can I connect to?",
                    answer: "As many as you want"
                },
                {
                    question: "How many Google SHEETS can I connect to?",
                    answer: "As many as you want"
                },
                {
                    question: "What size Google Sheets can I upload?",
                    answer: <span>Anything under 1,500 rows you can upload for free. See our {pricingPopup} to learn more!</span>,
                    searchAnswer: "Anything under 1,500 rows you can upload for free. See our pricing to learn more!"
                },
        ]
    },
    {
        info: {
            icon: 'dropbox',
            name: 'dropbox'
        },
        faq:[
                {
                    question: "What kind of files can I connect to in my Dropbox?",
                    answer: "You can connect to files with these extensions: .xls, .xlt, .xlm, .xlsx, .xlsm, .xltx, .xltm, .xlsb, .csv, .txt"
                },
                {
                    question: "How many Dropbox ACCOUNTS can I connect to?",
                    answer: "You can only connect to ONE account at a time. If you pick a file from another account, you will override the other account."
                },
                {
                    question: "How many Dropbox FILES can I connect to?",
                    answer: "As many as you want from your ONE account."
                },
                {
                    question: "How do I connect to the files?",
                    answer: "You can click on upload and select them or you can drag and drop them",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/UploadDropbox.png", alt: "Upload Dropbox"}
                },
                {
                    question: "What size files can I connect to?",
                    answer: <span>Anything under 1,500 rows you can upload for free. See our {pricingPopup} to learn more!</span>,
                    searchAnswer: "Anything under 1,500 rows you can upload for free. See our pricing to learn more!"
                },
        ]
    },
    {
        info: {
            icon: 'book',
            name: 'read-file'
        },
        faq: [
                {
                    question: "How are sheets in Excel Files read?",
                    answer: "We automatically read the first sheet. Then you can read any of the other sheets in the file"
                },
                {
                    question: "Can I change the sheet that was read?",
                    answer: "Yes, of course. You can click on the Change Sheet button and pick the valid sheet",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/ChangeSheet.png", alt: "Change Sheet Button", width: '35%'}
                },
                {
                    question: "How are CSV files read?",
                    answer: "They are automatically read with a comma delimiter. You can change the delimiter in the read options"
                },
                {
                    question: "Can I change my CSV delimiter?",
                    answer: "Yes, of course. You can click on the File Options button and pick the correct delimiter",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/FileOptions.png", alt: "File Options Menu", width: '35%'}
                },
                {
                    question: "How do you find the column names?",
                    searchAnswer: "We read the first row in the file as the header. You can change that in the read options. Column Names must be unique. You can read about it in our Column Names guide.",
                    answer: <span>We read the first row in the file as the header. You can change that in the read options. Column Names must be unique. You can read about it in our <a href="guides/column-names">Column Names</a> guide.</span>
                },
        ]
    },
    {
        info:{
            icon: 'code',
            name: 'api'
        },
        faq: [
                {
                    question: 'How do I get my API URL?',
                    answer: "You can get your Base API URL in your File Information box when you upload your file and afterwards in the files tab."
                },
                {
                    question: 'What kind of operations can I perform with the API?',
                    answer: 'You can perform all CRUD operations: Create, Read, Update and Delete'
                },
                {
                    question: 'How do I perform these operations?',
                    answer: <span>You make a GET request for Read or Delete or a POST request with Create or Update. You can read more details in the <a href="docs">API Docs</a> or the <a href="guides">Guides</a>. Or you can get started quickly and use the code snippets in your File Information boxes.</span>,
                    searchAnswer: "You make a GET request for Read or Delete or a POST request with Create or Update. You can read more details in the API Docs or the Guides. Or you can get started quickly and use the code snippets in your File Information boxes",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/QuickstartCode.png", alt: "Get Started Code"}
                },
                {
                    question: "What does making the API Private mean?",
                    answer: "Making the API Private will give you an access and secret key for that API. This feature is NOT available on the free plan"
                },
                {
                    question: 'What is your API up time?',
                    answer: <span>We guarantee a 99% constant up time and advise you at least 72 hours before any changes are to be made or we are expecting any downtime. You can check out the <a href="https://api-apispreadsheets-com.statuspal.io/" target="_blank" rel="noopener noreferrer">status</a> </span>,
                    searchAnswer: "We guarantee a 99% constant up time and advise you at least 72 hours before any changes are to be made or we are expecting any downtime. You can check out the status"
                },
                {
                    question: "How many requests can I make in a day?",
                    answer: <span>It depends on your plan. On the free plan you can make 1500 requests per day. See our {pricingPopup} to learn more</span>,
                    searchAnswer: "It depends on your plan. On the free plan you can make 1500 requests per day. See our pricing to learn more"
                },
                {
                    question: "How can I see how many requests I have made in a day?",
                    answer: "You can click on the API Usage button under file options.",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/APIUsage.png", alt: "API Usage Button", width: "35%"}
                }
        ]
    },
    {
        info: {
            icon: 'lock',
            name: 'security'
        },
        faq: [
                {
                    question: 'How is my data secured?',
                    answer: 'We use HTTPS/SSL in transmitting data to our server to keep it secure. We also store the data under encryption keys only accessible to one person.'
                },
                {
                    question: 'Do you guys store any data?',
                    answer: 'Yes, we store any local files you upload. If you delete the file then it is removed from our servers and database. We do NOT store your data from Google Sheets or Dropbox files.'
                },
                {
                    question: 'How can I trust you with the data?',
                    answer: "It's in our privacy policy and Terms & Conditions that we do not use the file data for ANY purpose."
                },
                {
                    question: "Do you offer on-prem installation?",
                    answer: <span>Yes! You can <a className="linkStyle" href="/contact-us">Contact Us</a> or <a className="linkStyle" href="mailto:info@apispreadsheets.com?Subject=On%20Prem%20Installation">Email Us</a> and we will get the process started.</span>,
                    searchAnswer: "Yes! You can Contact Us or Email Us and we will get the process started."
                }
        ]
    },
    {
        info: {
            icon: 'dollar sign',
            name: 'billing'
        },
        faq: [
                {
                    question: 'How do I upgrade my plan?',
                    answer: "You can do it through your Profile tab, the Upgrade tab or the Pricing Page",
                    image: {src: "https://project-static-assets.s3.amazonaws.com/APISpreadsheets/FAQImages/UpgradePaymentPlan.png", alt: "Upgrade Button", width: "65%"}
                },
                {
                    question: 'How do I pay for the plan?',
                    answer: <span>We accept all Credit Cards using <a href="https://www.stripe.com/" target="_blank" rel="noopener noreferrer">Stripe</a> as the payment provider, so we don't store or see your credit card number. If you wish to pay via invoice or any other payment methods, please <a href="contact-us">Contact Us</a>.</span>,
                    searchAnswer: "We accept all Credit Cards using Stripe as the payment provider, so we don't store or see your credit card number. If you wish to pay via invoice or any other payment methods, please Contact Us"
                },
                {
                    question: 'Are there any other fees?',
                    answer: <span>Nope, the price you see in our {pricingPopup} is the final price!</span>,
                    searchAnswer: "Nope, the price you see in our pricing is the final price!"
                },
                {
                    question: 'What does a month mean?',
                    answer: "A month begins and ends on the date you signed up. For ex: if you signed up on August 13th, then your month will renew on September 13th, October 13th and so on.",
                },
                {
                    question: "How long can I use the free plan for?",
                    answer: "As long as you want"
                },
                {
                    question: "What if I want to switch plans?",
                    answer: "You can do it through your Profile tab or the Pricing Page"
                },
                {
                    question: "What if I want to cancel my account?",
                    answer: <span>Simply email <a href="mailto:cancel@apispreadsheets.com?Subject=API%20Spreadsheets%Cancel%20Account"> cancel@apispreadsheets.com</a>from the email you signed up with and we will cancel your account!</span>,
                    searchAnswer: "Simply email cancel@apispreadsheets.com from the email you signed up with and we will cancel your account!"
                }
        ]
    },
]